var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "shimmer-wrapper", class: _vm.wrapperClass },
    [
      _vm.type === "stats-card"
        ? _vm._l(_vm.count, function (i) {
            return _c("div", { key: i, staticClass: "shimmer-stats-card" }, [
              _c("div", { staticClass: "shimmer-card-icon shimmer-animate" }),
              _vm._v(" "),
              _vm._m(0, true),
            ])
          })
        : _vm.type === "dashboard-card"
        ? _vm._l(_vm.count, function (i) {
            return _c(
              "div",
              { key: i, staticClass: "shimmer-dashboard-card" },
              [_vm._m(1, true), _vm._v(" "), _vm._m(2, true)]
            )
          })
        : _vm.type === "table"
        ? [
            _c(
              "div",
              { staticClass: "shimmer-table" },
              [
                _c(
                  "div",
                  { staticClass: "shimmer-table-header" },
                  _vm._l(_vm.columns, function (col) {
                    return _c("div", {
                      key: "header-" + col,
                      staticClass: "shimmer-table-cell shimmer-animate",
                      style: { width: `${100 / _vm.columns}%` },
                    })
                  }),
                  0
                ),
                _vm._v(" "),
                _vm._l(_vm.count, function (row) {
                  return _c(
                    "div",
                    { key: row, staticClass: "shimmer-table-row" },
                    _vm._l(_vm.columns, function (col) {
                      return _c("div", {
                        key: "cell-" + row + "-" + col,
                        staticClass: "shimmer-table-cell shimmer-animate",
                        style: { width: `${100 / _vm.columns}%` },
                      })
                    }),
                    0
                  )
                }),
              ],
              2
            ),
          ]
        : _vm.type === "settings-card"
        ? _vm._l(_vm.count, function (i) {
            return _c("div", { key: i, staticClass: "shimmer-settings-card" }, [
              _c("div", { staticClass: "shimmer-icon-circle shimmer-animate" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "shimmer-line shimmer-line-md shimmer-animate",
                staticStyle: { width: "70%", "margin-top": "15px" },
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "shimmer-line shimmer-line-xs shimmer-animate",
                staticStyle: { width: "90%", "margin-top": "8px" },
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "shimmer-line shimmer-line-xs shimmer-animate",
                staticStyle: { width: "50%", "margin-top": "15px" },
              }),
            ])
          })
        : _vm.type === "form"
        ? [
            _c(
              "div",
              { staticClass: "shimmer-form" },
              _vm._l(_vm.count, function (i) {
                return _c(
                  "div",
                  { key: i, staticClass: "shimmer-form-group" },
                  [
                    _c("div", { staticClass: "shimmer-label shimmer-animate" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "shimmer-input shimmer-animate" }),
                  ]
                )
              }),
              0
            ),
          ]
        : _vm.type === "chart"
        ? [_vm._m(3)]
        : _vm.type === "list"
        ? _vm._l(_vm.count, function (i) {
            return _c("div", { key: i, staticClass: "shimmer-list-item" }, [
              _c("div", { staticClass: "shimmer-avatar shimmer-animate" }),
              _vm._v(" "),
              _vm._m(4, true),
            ])
          })
        : _vm.type === "quick-links"
        ? [
            _c(
              "div",
              { staticClass: "shimmer-quick-links" },
              _vm._l(_vm.count, function (i) {
                return _c("div", {
                  key: i,
                  staticClass: "shimmer-quick-link-btn shimmer-animate",
                })
              }),
              0
            ),
          ]
        : [
            _c(
              "div",
              { staticClass: "shimmer-text" },
              _vm._l(_vm.count, function (i) {
                return _c("div", {
                  key: i,
                  staticClass: "shimmer-line shimmer-animate",
                  class: [`shimmer-line-${_vm.size}`],
                  style: { width: _vm.getRandomWidth() },
                })
              }),
              0
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "shimmer-card-content" }, [
      _c("div", {
        staticClass: "shimmer-line shimmer-line-lg shimmer-animate",
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "shimmer-line shimmer-line-sm shimmer-animate",
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "shimmer-card-header" }, [
      _c("div", {
        staticClass: "shimmer-line shimmer-line-md shimmer-animate",
        staticStyle: { width: "60%" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "shimmer-card-body" }, [
      _c("div", { staticClass: "shimmer-chart shimmer-animate" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "shimmer-chart-container" }, [
      _c("div", { staticClass: "shimmer-chart-title shimmer-animate" }),
      _vm._v(" "),
      _c("div", { staticClass: "shimmer-chart-area shimmer-animate" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "shimmer-list-content" }, [
      _c("div", {
        staticClass: "shimmer-line shimmer-line-md shimmer-animate",
        staticStyle: { width: "80%" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "shimmer-line shimmer-line-sm shimmer-animate",
        staticStyle: { width: "60%" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }